import { useEffect } from 'react';
import { languages, defaultLanguage } from '../config/languages';
import { useLanguage } from './useLanguage';

// Sets a descriptive <title> for the current page (WCAG 2.4.2 Page Titled),
// in the form "Page name - UK Web Archive" (site name localised). Pass a null
// title to leave the document title untouched — e.g. while a child such as
// ErrorPage is responsible for it.
export function useDocumentTitle(title, langCode = defaultLanguage) {
  useEffect(() => {
    if (title == null) return;
    const siteTitle = (languages[langCode] || languages[defaultLanguage]).siteTitle;
    const page = String(title).trim();
    document.title = page && page !== siteTitle ? `${page} - ${siteTitle}` : siteTitle;
  }, [title, langCode]);
}

// Keeps <html lang> in step with the locale in the URL (WCAG 3.1.1 Language of
// Page), so screen readers switch to Welsh / Gaelic pronunciation on /cy and
// /gd pages. index.html sets the same value before first paint.
export function useDocumentLang() {
  const { code } = useLanguage();
  useEffect(() => {
    document.documentElement.lang = code;
  }, [code]);
}
